import { Controller } from "@hotwired/stimulus";

export default class SearchFieldController extends Controller<HTMLElement> {
	static targets = ["input"];

	declare inputTarget: HTMLInputElement;

	clear() {
		this.inputTarget.value = "";
		// let anything listening for typing (suggestions, autosubmit) know the field is empty
		this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }));
		this.inputTarget.focus();
	}
}
